import {
  GET_LABREQUEST,
  GET_LABREQUEST_FAIL,
  GET_LABREQUEST_SUCCESS,
  GET_LABREQUESTS,
  GET_LABREQUESTS_FAIL,
  GET_LABREQUESTSREPORTDETAIL,
  GET_LABREQUESTSREPORTDETAIL_FAIL,
  GET_LABREQUESTSREPORTDETAIL_SUCCESS,
  GET_LABREQUESTS_SUCCESS,
  ADD_NEW_LABREQUEST,
  ADD_LABREQUEST_SUCCESS,
  ADD_LABREQUEST_FAIL,
  UPDATE_LABREQUEST,
  UPDATE_LABREQUEST_SUCCESS,
  UPDATE_LABREQUEST_FAIL,
  DELETE_LABREQUEST,
  DELETE_LABREQUEST_SUCCESS,
  DELETE_LABREQUEST_FAIL,
  SET_STATE_LABREQUEST
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_LABREQUEST,
  payload: loading,
})

export const getLabRequests = ( params ) => ({
  type: GET_LABREQUESTS,
  payload: { params },
})

export const getLabRequestsSuccess = (labRequests, totalPages, currentPage) => ({
  type: GET_LABREQUESTS_SUCCESS,
  payload: { labRequests:labRequests, total:totalPages, currentPage:currentPage}
})

export const getLabRequestsFail = error => ({
  type: GET_LABREQUESTS_FAIL,
  payload: error,
})

export const getLabRequestsReportDetail = ( params ) => ({
  type: GET_LABREQUESTSREPORTDETAIL,
  payload: { params },
})

export const getLabRequestsReportDetailSuccess = (labRequestsReportDetail) => ({
  type: GET_LABREQUESTSREPORTDETAIL_SUCCESS,
  payload: { labRequestsReportDetail:labRequestsReportDetail}
})

export const getLabRequestsReportDetailFail = error => ({
  type: GET_LABREQUESTSREPORTDETAIL_FAIL,
  payload: error,
})

export const addNewLabRequest = labRequest => ({
  type: ADD_NEW_LABREQUEST,
  payload: labRequest,
})

export const addLabRequestSuccess = labRequest => ({
  type: ADD_LABREQUEST_SUCCESS,
  payload: labRequest,
})  

export const addLabRequestFail = error => ({
  type: ADD_LABREQUEST_FAIL,
  payload: error,
})

export const updateLabRequest = labRequest => ({
  type: UPDATE_LABREQUEST,
  payload: labRequest,
})

export const updateLabRequestSuccess = labRequest => ({
  type: UPDATE_LABREQUEST_SUCCESS,
  payload: labRequest,
})

export const updateLabRequestFail = error => ({
  type: UPDATE_LABREQUEST_FAIL,
  payload: error,
})

export const deleteLabRequest = labRequest => ({
  type: DELETE_LABREQUEST,
  payload: labRequest,
})

export const deleteLabRequestSuccess = id => ({
  type: DELETE_LABREQUEST_SUCCESS,
  id,
})

export const deleteLabRequestFail = error => ({
  type: DELETE_LABREQUEST_FAIL,
  payload: error,
})

export const getLabRequest = ( params ) => ({
  type: GET_LABREQUEST,
  payload: { params },
})

export const getLabRequestSuccess = labRequest => ({
  type: GET_LABREQUEST_SUCCESS,
  payload: labRequest,
})

export const getLabRequestFail = error => ({
  type: GET_LABREQUEST_FAIL,
  payload: error,
})
